module.exports = __webpack_public_path__ + "img/personal-web04.49ff5636.png";